/**
 * For each listed host id there is a <CURRENT_HOST_ID>.settings.ts file, that needs to be adjusted if you enrich this enum!
 * Expections are mentioned by comment
 */
export enum HostId {
  Unknown = 'unknown',
  Local = 'localhost',
  Dev = 'dev',
  Test = 'test',
  Int = 'int',
  PreProd = 'preprod',
  Prod = 'prod',
  Expert = 'expert', // BE deployment: Expert INT
  TimeTravel = 'timeTravel', // BE deployment: timetravel to test new supersecret stuff
  CustomBackend = 'customBackend', // BE deployment: others
  UnitTestEnvironment = 'unitTestEnvironment' // to identify test runner
}
